import { FC, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { useGetBillingAccessUrlQuery } from '../services/apiSlice';

import { Loading } from '../components/Loading';

const BillingAccessToken: FC = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetBillingAccessUrlQuery(token ?? '', {
    skip: !token,
  });

  useEffect(() => {
    if (data?.url) {
      window.location.href = data.url;
    }
  }, [data]);

  return (
    <>
      <div className="grid overflow-hidden py-10 px-12 m-3 rounded-lg shadow-xl border-tttDefault border-[1px] w-80">
        <div className="box mb-3">
          <h1 className="text-xl font-bold text-center">
            Manage your subscription
          </h1>
        </div>
        <div className="box">
          {isLoading ? (
            <div className="flex justify-center items-center h-[160px]">
              <Loading />
            </div>
          ) : (
            <div className="px-1 py-4 font-medium text-center">
              {error ? (
                <>
                  <p className="mb-2">
                    This link is invalid, expired or already used.
                  </p>
                  <p className="text-sm text-gray-600 mb-2">
                    Request a new one and use it within an hour.
                  </p>
                  <button
                    onClick={() => navigate('/billing-access')}
                    className="text-sm text-tttDefault hover:underline cursor-pointer"
                  >
                    Request a new subscription link
                  </button>
                </>
              ) : (
                <p>Redirecting to the secure billing portal...</p>
              )}
            </div>
          )}
        </div>
        <div className="text-center mt-4">
          <Link
            to={'/login'}
            className="text-sm text-tttDefault hover:underline"
          >
            Back to login
          </Link>
        </div>
      </div>
    </>
  );
};

export default BillingAccessToken;
